import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NormalHeader from '../components/NormalHeader';
import NormalFooter from '../components/NormalFooter';
import { useNormalReservation } from '../context/NormalReservationContext';

const NormalFormStep2: React.FC = () => {
  const navigate = useNavigate();
  const { clinic, dateTime, personalInfo, setPersonalInfo } = useNormalReservation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!clinic || !dateTime) {
      navigate('/form/normal/form1');
    }
  }, [clinic, dateTime, navigate]);

  const handleChange = (field: keyof typeof personalInfo, value: string) => {
    setPersonalInfo({ [field]: value });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!personalInfo.lastName || !personalInfo.firstName || !personalInfo.phone || !personalInfo.email) {
      setError('必須項目を入力してください。');
      return;
    }
    setError(null);
    navigate('/form/normal/confirmation');
  };

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <NormalHeader />
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10 sm:px-6">
        <div className="mb-6">
          <p className="text-sm font-semibold text-brand-primary">Step 2</p>
          <h1 className="text-2xl font-bold text-gray-900">個人情報を入力</h1>
          <p className="text-sm text-gray-600">必須項目を入力して次へ進んでください。</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
          {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}

          <div className="grid gap-4 sm:grid-cols-2">
            <label className="space-y-1 text-sm font-semibold text-gray-800">
              姓（漢字）<span className="text-brand-accent">*</span>
              <input
                className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
                value={personalInfo.lastName}
                onChange={(e) => handleChange('lastName', e.target.value)}
              />
            </label>
            <label className="space-y-1 text-sm font-semibold text-gray-800">
              名（漢字）<span className="text-brand-accent">*</span>
              <input
                className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
                value={personalInfo.firstName}
                onChange={(e) => handleChange('firstName', e.target.value)}
              />
            </label>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <label className="space-y-1 text-sm font-semibold text-gray-800">
              せい（かな）
              <input
                className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
                value={personalInfo.lastNameKana}
                onChange={(e) => handleChange('lastNameKana', e.target.value)}
              />
            </label>
            <label className="space-y-1 text-sm font-semibold text-gray-800">
              めい（かな）
              <input
                className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
                value={personalInfo.firstNameKana}
                onChange={(e) => handleChange('firstNameKana', e.target.value)}
              />
            </label>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <label className="space-y-1 text-sm font-semibold text-gray-800">
              電話番号<span className="text-brand-accent">*</span>
              <input
                className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
                value={personalInfo.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
              />
            </label>
            <label className="space-y-1 text-sm font-semibold text-gray-800">
              メールアドレス<span className="text-brand-accent">*</span>
              <input
                type="email"
                className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
                value={personalInfo.email}
                onChange={(e) => handleChange('email', e.target.value)}
              />
            </label>
          </div>

          <label className="space-y-1 text-sm font-semibold text-gray-800">
            ご要望・ご質問
            <textarea
              className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary"
              rows={3}
              value={personalInfo.request}
              onChange={(e) => handleChange('request', e.target.value)}
            />
          </label>

          <div className="flex flex-wrap items-center justify-between gap-3">
            <button
              type="button"
              onClick={() => navigate('/form/normal/form1')}
              className="inline-flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50"
            >
              戻る
            </button>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => navigate('/form/normal')}
                className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50"
              >
                ステップに戻る
              </button>
              <button
                type="submit"
                className="inline-flex items-center justify-center rounded-lg bg-brand-primary px-4 py-2 text-sm font-semibold text-white shadow hover:bg-green-600"
              >
                内容を確認する
              </button>
            </div>
          </div>
        </form>
      </main>
      <NormalFooter />
    </div>
  );
};

export default NormalFormStep2;
